export type SwipeDirection = 'left' | 'right';

export const detectSwipeEvent = (
  element: HTMLElement,
  callback: (direction: SwipeDirection) => void,
): void => {
  let touchStartX: number = 0;
  let touchEndX: number = 0;

  const handleTouchStart = (event: TouchEvent): void => {
    touchStartX = event.touches[0].clientX;
  };

  const handleTouchEnd = (event: TouchEvent): void => {
    if (touchStartX >= 22 && touchStartX <= 370) return;
    event.preventDefault();
    touchEndX = event.changedTouches[0].clientX;

    const threshold: number = 50;

    const diffX: number = touchEndX - touchStartX;

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        callback('right');
      } else {
        callback('left');
      }
    }
  };

  const handleTouchMove = (event: TouchEvent): void => {
    event.preventDefault();
  };

  element.addEventListener('touchstart', handleTouchStart, { passive: true });
  element.addEventListener('touchend', handleTouchEnd, { passive: true });
  element.addEventListener('touchmove', handleTouchMove, { passive: true });
};
